export class IsIndeterminate implements ng.IDirective {
	restrict = 'A';
	scope = {
		'isIndeterminate': '='
	};
	constructor() {
		this.link = (scope: ng.IScope, element: ng.IAugmentedJQuery,
					 attrs: ng.IAttributes) => {
			scope.$watch('isIndeterminate', () => {
				element.prop('indeterminate', scope['isIndeterminate']);
			});
		}
	}

	link: ($scope: ng.IScope, element: ng.IAugmentedJQuery,
		   attrs: ng.IAttributes) => void = null;

	static factory(): ng.IDirectiveFactory {
		const directive = () => new IsIndeterminate();
		directive.$inject = [];
		return directive;
	}
}